import { createSlice } from "@reduxjs/toolkit";
import { allCutomerNotificationsType } from "../../../utils/types";
import { getCustomerNotifications } from "../http/getNotifications";

type NotificationsType = {
  notifications: allCutomerNotificationsType;
};

const initialState: NotificationsType = {
  notifications: {},
};

export const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCustomerNotifications.fulfilled, (state, action) => {
      state.notifications = action.payload;
    });
  },
});

export default notificationsSlice.reducer;
